import Config from './../config';

export default {
  getBrowserLocale: function () {
    let languages = navigator.languages;
    if (languages === null || languages === undefined) {
      if (navigator.userLanguage !== null) {
        languages = [navigator.userLanguage, navigator.systemLanguage];
      } else {
        languages = [];
      }
    }
    return languages;
  },

  getInitLocale: function () {
    const { locales } = Config;
    let browserLocales = this.getBrowserLocale();
    for (let fullBrowserLocale of browserLocales) {
      // check for exact match e.g. en-GB
      if (locales.findIndex(l => l.code === fullBrowserLocale) > -1) {
        return fullBrowserLocale;
      }
      // check for part match e.g. en
      let partBrowserLocale = fullBrowserLocale.split('-')[0];
      if (partBrowserLocale === fullBrowserLocale) {
        continue;
      }
      if (locales.findIndex(l => l.code === partBrowserLocale) > -1) {
        return partBrowserLocale;
      }
    }
    return locales[0].code;
  },

  getLocale: function () {
    return window.i18n.locale;
  },

  setLocale: function (locale) {
    window.i18n.locale = locale;
  }
}



// WEBPACK FOOTER //
// ./src/services/locale-service.js